<template>
  <div class="variable-selector">
    <!--<label v-if="label">{{ label }}</label>-->
    <b-form-select
      class="timeTypeList"
      v-model="timeType"
      size="lg"
      :options="timeOptionList"
      :title="
        viewType == 'mapView'
          ? 'Éves vagy éven belüli időszak, amelyre a 30-éves átlagos értékek vagy változások vonatkoznak'
          : 'Éves vagy éven belüli időszak, amelyre az adatok 30-éves mozgóátlaga vonatkozik'
      "
    >
      <template #first>
        <b-form-select-option :value="null" selected hidden disabled
          >Időszak</b-form-select-option
        >
      </template>
    </b-form-select>
  </div>
</template>

<script>
export default {
  name: "TimeSelector",
  props: {
    variableMap: {
      type: Map,
      default: () => new Map(),
    },
    value: {
      type: String,
      default: "",
    },
    viewType: {
      type: String,
      default: "mapView",
    },
    modelType: {
      type: String,
      default: "climate",
    },
    variableNotation: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      timeType: null,
      annual: {
        value: "ann",
        text: "Éves",
      },
      seasonal: {
        text: "Évszakos",
        options: [
          {
            value: "MAM",
            text: "Tavasz",
          },
          {
            value: "JJA",
            text: "Nyár",
          },
          {
            value: "SON",
            text: "Ősz",
          },
          {
            value: "DJF",
            text: "Tél",
          },
        ],
      },
      monthly: {
        value: "month",
        text: "Havi",
        options: [
          {
            value: "01",
            text: "Január",
          },
          {
            value: "02",
            text: "Február",
          },
          {
            value: "03",
            text: "Március",
          },
          {
            value: "04",
            text: "Április",
          },
          {
            value: "05",
            text: "Május",
          },
          {
            value: "06",
            text: "Június",
          },
          {
            value: "07",
            text: "Július",
          },
          {
            value: "08",
            text: "Augusztus",
          },
          {
            value: "09",
            text: "Szeptember",
          },
          {
            value: "10",
            text: "Október",
          },
          {
            value: "11",
            text: "November",
          },
          {
            value: "12",
            text: "December",
          },
        ],
      },
    };
  },
  computed: {
    variableList() {
      let viewType = this.viewType;
      let modelType = this.modelType;
      console.log(this.variableMap);
      if (this.variableMap.has("mapView")) {
        let localVariableMap = this.variableMap.get(viewType).get(modelType);
        if (!localVariableMap.has(this.selectedVariable)) {
          this.selectedVariable = null;
        }
        return Array.from(localVariableMap.values());
      }
    },
    timeOptionList: function () {
      if (!this.variableMap.has("mapView")) {
        //this.timeType = null;
        console.warn("No variableMap for mapView.");
        return [];
      }
      if (!this.variableNotation) {
        this.timeType = null;
        console.warn("No variableNotation set.");
        return [];
      }
      let variableNotation = this.variableNotation;
      let viewType = this.viewType;
      let modelType = this.modelType;
      let variableObject = this.variableMap
        .get(viewType)
        .get(modelType)
        .get(variableNotation);
      let timeOptionObject = [];
      let helpArray = [];
      if (variableObject.yearly_break_up) {
        timeOptionObject.push(this.annual);
        helpArray.push("ann");
      }
      if (variableObject.seasonal_break_up) {
        timeOptionObject.push(this.seasonal);
        helpArray.push("MAM", "JJA", "SON", "DJF");
      }
      if (variableObject.monthly_break_up) {
        timeOptionObject.push(this.monthly);
        helpArray.push(
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
        );
      }
      if (!helpArray.includes(this.timeType)) {
        this.timeType = "ann";
        console.warn("timeType not in available options, setting to 'ann'.");
      }
      return timeOptionObject;
    },
  },
  watch: {
    value(newVal) {
      console.warn("Time selector value prop changed:", newVal);
      this.timeType = newVal;
    },
    timeType(newVal) {
      this.$emit("input", newVal);
    },
  },
  methods: {
    onChange() {
      //this.$emit('input', this.selectedVariable);
      this.$emit("selectedVariableChanged", this.selectedVariable);
    },
  },
};
</script>

<style scoped>
.variable-selector {
  margin-bottom: 1rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.variable-select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  font-size: 1rem;
}
</style>
